import { AiFilterValuesResponse } from '@kimuno/api-sdk/lib/types/responses/Text';
import { AsyncAction } from './common.actionTypes';

export enum FETCH_AI_FILTER_VALUES {
  START = 'FETCH_AI_FILTER_VALUES_START',
  SUCCESS = 'FETCH_AI_FILTER_VALUES_SUCCESS',
  ERROR = 'FETCH_AI_FILTER_VALUES_ERROR',
}

export type FetchAiFilterValuesAction = AsyncAction<
  FETCH_AI_FILTER_VALUES.START,
  FETCH_AI_FILTER_VALUES.SUCCESS,
  FETCH_AI_FILTER_VALUES.ERROR,
  AiFilterValuesResponse
>;
